import { render, staticRenderFns } from "./logisticstracking.vue?vue&type=template&id=017d8919&scoped=true"
import script from "./logisticstracking.vue?vue&type=script&lang=ts"
export * from "./logisticstracking.vue?vue&type=script&lang=ts"
import style0 from "./logisticstracking.vue?vue&type=style&index=0&id=017d8919&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "017d8919",
  null
  
)

export default component.exports